module.exports = __webpack_public_path__ + "d36928416b10f99d5b8cdc1a42a0f06d.png";